import React from 'react';
import { 
  LuChevronRight, 
  LuShieldCheck, 
  LuWrench, 
  LuLeaf 
} from 'react-icons/lu';

// Safe, version-independent status and category indicators
import { 
  FiClock, 
  FiUserX, 
  FiAlertOctagon, 
  FiShield 
} from 'react-icons/fi';


export default function IncidentDashboardTables() {
  // Data for Incidents by Category Table
  const categoryData = [
    { category: 'Food Safety', total: 8, open: 2, closed: 6, overdue: 1, nearMiss: 1, icon: LuShieldCheck, iconColor: 'text-emerald-600' },
    { category: 'Customer Safety', total: 4, open: 1, closed: 3, overdue: 0, nearMiss: 0, icon: FiClock, iconColor: 'text-orange-500' },        // <--- FIXED: Swapped to FiClock
    { category: 'Staff Injury', total: 3, open: 1, closed: 2, overdue: 0, nearMiss: 0, icon: FiUserX, iconColor: 'text-indigo-600' },         // <--- FIXED: Swapped to FiUserX
    { category: 'Equipment / Facilities', total: 3, open: 1, closed: 2, overdue: 1, nearMiss: 0, icon: LuWrench, iconColor: 'text-purple-600' },
    { category: 'Slip / Trip / Fall', total: 2, open: 0, closed: 2, overdue: 0, nearMiss: 0, icon: FiAlertOctagon, iconColor: 'text-rose-600' }, // <--- FIXED: Swapped to FiAlertOctagon
    { category: 'Security', total: 1, open: 0, closed: 1, overdue: 0, nearMiss: 0, icon: FiShield, iconColor: 'text-teal-600' },            // <--- FIXED: Swapped to FiShield
    { category: 'Environmental', total: 1, open: 0, closed: 1, overdue: 0, nearMiss: 0, icon: LuLeaf, iconColor: 'text-green-600' },
  ];

  // Data for Incidents by Location Table
  const locationData = [
    { location: 'Kitchen', total: 12, open: 3, closed: 8, overdue: 1 },
    { location: 'Bar Area', total: 4, open: 1, closed: 3, overdue: 0 },
    { location: 'Dining Area', total: 3, open: 1, closed: 2, overdue: 1 },
    { location: 'Store Room', total: 2, open: 0, closed: 2, overdue: 0 },
    { location: 'Front of House', total: 1, open: 0, closed: 1, overdue: 0 },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 max-w-[1800px] mx-auto items-stretch">
        
        {/* Left Card: Incidents by Category */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-sm font-bold text-indigo-950 mb-5">
              Incidents by Category
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[35%]">CATEGORY</th>
                    <th className="p-3 text-center">TOTAL</th>
                    <th className="p-3 text-center">OPEN</th>
                    <th className="p-3 text-center">CLOSED</th>
                    <th className="p-3 text-center">OVERDUE</th>
                    <th className="p-3 text-center rounded-r-lg">NEAR MISS</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-bold text-slate-700 divide-y divide-slate-100/70">
                  {categoryData.map((row, index) => {
                    const CategoryIcon = row.icon;
                    return (
                      <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                        <td className="p-3 text-slate-800 font-extrabold flex items-center gap-2">
                          <CategoryIcon className={`${row.iconColor} text-sm flex-shrink-0`} />
                          <span>{row.category}</span>
                        </td>
                        <td className="p-3 text-center text-slate-900 font-extrabold">{row.total}</td>
                        <td className={`p-3 text-center ${row.open > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.open}</td>
                        <td className={`p-3 text-center ${row.closed > 0 ? 'text-slate-600' : 'text-slate-400'}`}>{row.closed}</td>
                        <td className={`p-3 text-center ${row.overdue > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.overdue}</td>
                        <td className="p-3 text-center text-indigo-950/80">{row.nearMiss}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1 w-full text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View all incidents</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Right Card: Incidents by Location */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-sm font-bold text-indigo-950 mb-5">
              Incidents by Location
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[40%]">LOCATION</th>
                    <th className="p-3 text-center">TOTAL</th>
                    <th className="p-3 text-center">OPEN</th>
                    <th className="p-3 text-center">CLOSED</th>
                    <th className="p-3 text-center rounded-r-lg">OVERDUE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-bold text-slate-700 divide-y divide-slate-100/70">
                  {locationData.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-3 text-slate-800 font-extrabold">{row.location}</td>
                      <td className="p-3 text-center text-slate-900 font-extrabold">{row.total}</td>
                      <td className={`p-3 text-center ${row.open > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.open}</td>
                      <td className={`p-3 text-center ${row.closed > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.closed}</td>
                      <td className={`p-3 text-center ${row.overdue > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.overdue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1 w-full text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View all locations</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
